import { initFirebase } from '@snippits/shared/firebase';

export const firebase = initFirebase(
  {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
  {
    appCheckSiteKey: import.meta.env.VITE_RECAPTCHA_V3_SITE_KEY,
    appCheckDebug: import.meta.env.DEV,
  },
);
